import Vue from 'vue'
import {
  Image as VanImage,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  // Grid,
  // GridItem,
  Divider,
  NavBar,
  Icon,
  RadioGroup,
  Radio,
  // Area,
  List,
  PullRefresh,
  Col,
  Row,
  Tab,
  Tabs,
  Dialog,
  Toast,
  // Badge,
  Loading,
  Swipe,
  SwipeItem,
  // Lazyload,
  // Sku,
  Cell,
  DatetimePicker,
  Checkbox,
  CheckboxGroup,
  Search,
  Tabbar,
  TabbarItem,
  Empty,
  Circle,
  Switch,
  Popover
} from 'vant'

Vue.use(VanImage)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Picker)
Vue.use(Popup)
// Vue.use(Grid)
// Vue.use(GridItem)
Vue.use(Divider)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(RadioGroup)
Vue.use(Radio)
// Vue.use(Area)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Dialog)
Vue.use(Toast)
// Vue.use(Badge)
Vue.use(Loading)
Vue.use(Swipe)
Vue.use(SwipeItem)
// Vue.use(Lazyload)
// Vue.use(Sku)
Vue.use(Cell)
Vue.use(DatetimePicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Search)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Empty)
Vue.use(Circle)
Vue.use(Switch)
Vue.use(Popover)
